module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.c27ae785.eot";